/**
 * 编辑视图模块路由（优化版）
 */
export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/home",
    children: [
      {
        path: "clue",  // 使用相对路径
        component: resolve => require(["@/modules/clue/pages/index.vue"], resolve),
        redirect: "/menu/clue/cluelist",
        children: [
          {
            path: "cluelist",  
            component: resolve => require(["@/modules/clue/pages/clueList/clueList.vue"], resolve)
          },
          {
            path: "cluelist/cluedetail/:id",  
            name: "cluedetail",
            component: resolve => require(["@/modules/clue/pages/clueList/clueDetail.vue"], resolve)
          },
          {
            path: "cluereceive/seting",  
            component: resolve => require(["@/modules/clue/pages/clueReceive/clueReceive.vue"], resolve)
          },
          {
            path: "cluereceive/seting/organization", 
            component: resolve => require(["@/modules/clue/pages/clueReceive/organization.vue"], resolve)
          },
          {
            path: "cluereceive/seting/channelSetting", 
            component: resolve => require(["@/modules/clue/pages/clueReceive/channelSetting.vue"], resolve)
          },
          {
            path: "cluereceive/seting/ccOrganization",  
            component: resolve => require(["@/modules/clue/pages/clueReceive/ccOrganization.vue"], resolve)
          },
          {
            path: "cluereceive/seting/customRules",  
            component: resolve => require(["@/modules/clue/pages/clueReceive/customRules.vue"], resolve)
          },
          {
            path: "cluereceive/syncRules", 
            component: resolve => require(["@/modules/clue/pages/clueReceive/syncRules.vue"], resolve)
          },
          {
            path: "cluereceive/noRepeat",  
            component: resolve => require(["@/modules/clue/pages/clueReceive/cluenoRepeat.vue"], resolve)
          },
          {
            path: "cluesetting",  
            component: resolve => require(["@/modules/clue/pages/clueSetting/clueSetting.vue"], resolve)
          }
        ]
      }
    ]
  }
];
